import { Observable } from 'rxjs';

import { db } from '@/main';
import { dbNewsDataToNewsItems, NewsItem } from '@/views/Press/news.model';
// import { NewsApiResponse, NewsFormat } from '@/models/news-api.model';

export const getNewsItems = (): Observable<NewsItem[]> =>
    new Observable(observer => {
        db.ref('/news')
            .once('value')
            .then(snapshot => {
                const data = snapshot.val();
                data ? observer.next(dbNewsDataToNewsItems(data)) : observer.error('no data');
                observer.complete();
            });
    });

// This is really sloppy I know, but I didn't feel like doing more since I only really need to call this every once in a while.
// If the news section needs updated, just uncomment the below and run the app once. You will also need to go into the firebase console
// and change the realtime database rules to allow public read/write access temporarily.
// After running once, comment it back out and change the rules back to secure it.

// const getNews = () =>
//     fetch(
//         "https://real-time-news-data.p.rapidapi.com/search?query=Merrill's%20Marauders&limit=99&time_published=anytime&country=US&lang=en",
//         {
//             method: 'GET',
//             headers: {
//                 'x-rapidapi-key': '66a71752f9msh81315f7733f3ba6p13716ajsnaa5a8c36a42e',
//                 'x-rapidapi-host': 'real-time-news-data.p.rapidapi.com'
//             }
//         }
//     ).then(res => {
//         return res.json().then((data: NewsApiResponse) => {
//             if (data && data.data && data.data.length) {
//                 const formattedArticles: NewsFormat[] = data.data.map((article, index) => ({
//                     id: `news-${index + 1}`,
//                     link: article.link,
//                     published: article.published_datetime_utc,
//                     source: {
//                         href: article.source_url,
//                         title: article.source_name
//                     },
//                     title: article.title
//                 }));
//                 return db.ref('/news/').set(formattedArticles);
//             }
//             return;
//         });
//     });
// getNews();
